import css from "styled-jsx/css";

/* ==========================================================================
   🎯 GUÍA DE ASIGNACIÓN PARA EL PLAYGROUND (BACKOFFICE)
   ========================================================================== */
export const AVAILABLE_ANIMATIONS = [
  "fadeIn",
  "fadeInUp",
  "fadeInDown",
  "slideInLeft",
  "slideInRight",
  "popIn",
  "zoomIn",
  "revealText",
  "flipInX",
  "elementPulse",
  "shimmerCTA",
  "bounceMarker",
  "glitchAttention",
  "heartbeat",
  "floatLoop",
  "zoomInBg",
  /* Nuevas animaciones específicas para la campaña Black Friday 2026 */
  "rotateBlack",
  "rotateName",
  "neonFriday",
];

export default css`
  .animated-banner {
    overflow: hidden !important;
    overflow-y: hidden !important;
    box-sizing: border-box;
  }

  .animated-banner :global(.text-size--text-preset-10) {
    line-height: 1 !important;
    font-size: clamp(2.875rem, 1.389vw + 1.833rem, 3.5rem) !important;
  }

  .tablet.animated-banner :global(.text-size--text-preset-10) {
    font-size: clamp(2.25rem, 2vw + 1.375rem, 2.875rem) !important;
  }

  .mobile.animated-banner :global(.text-size--text-preset-10) {
    font-size: clamp(1.625rem, 2.63vw + 1.1rem, 2.25rem) !important;
  }

   
  .animated-banner :global(.text-size--text-preset-06) {
    line-height: 1 !important;
    font-size: 1.75rem !important;
  }

  .animated-banner :global(.text-size--text-preset-07) {
    line-height: 1 !important;
    font-size: 2.625rem !important; 
  }


  .tablet.animated-banner :global(.text-size--text-preset-06) {
    font-size: clamp(1.375rem, 1.2vw + 0.85rem, 1.75rem) !important;
  }

  .tablet.animated-banner :global(.text-size--text-preset-07) {
    font-size: clamp(1.375rem, 1.8vw + 0.75rem, 2.625rem) !important; 
  }

  .mobile.animated-banner :global(.text-size--text-preset-06) {
    font-size: clamp(0.75rem, 1.43vw + 0.55rem, 1.375rem) !important;
  }

  .mobile.animated-banner :global(.text-size--text-preset-07) {
    font-size: clamp(0.75rem, 1.43vw + 0.55rem, 1.375rem) !important; 
  }

  .mobile.animated-banner :global(.text-size--text-preset-03) {
    line-height: 1 !important;
    font-size: clamp(0.875rem, 2.1vw + 0.455rem, 1.375rem) !important;
  }

  .animated-banner :global(#Text-username),
  .animated-banner :global(#Text-black) {
    top: 50% !important;
    transform: translateY(-100%) !important;
    bottom: auto !important;
  }
  .animated-banner :global(#Text-friday) {
    top: 50% !important;
    transform: translateY(0%) !important;
    bottom: auto !important;
  }

  .mobile.animated-banner :global(#Text-username),
  .mobile.animated-banner :global(#Text-black) {
    top: 50% !important;
    transform: translateY(-100%) translateY(-0.75rem) !important;
  }
  .mobile.animated-banner :global(#Text-friday) {
    top: 50% !important;
    transform: translateY(-50%) !important;
  }
  .mobile.animated-banner :global(#Text-1793099138655-320u6) {
    top: 50% !important;
    transform: translateY(0%) translateY(1.5rem) !important;
    bottom: auto !important;
  }

  /* ==========================================================================
     🚀 REGLAS GLOBALES PARA EL MOTOR INTERNO (CAMPÁÑA BLACK FRIDAY 2026)
     ========================================================================== */

  /* Forzamos la perspectiva 3D en el contenedor raíz para el giro lateral */
  :global(#animated-banner-root),
  :global(.animated-banner) {
    perspective: 1200px !important;
  }

  /* Preparamos todas las capas con capacidades 3D globales y ocultación de espalda */
  :global(.banner-scene-layer) {
    transform-style: preserve-3d !important;
    backface-visibility: hidden !important;
    -webkit-backface-visibility: hidden !important;
  }
`;
